import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/common/Card';
import Button from '../components/common/Button';

const Vote = () => {
  return (
    <div style={{ backgroundColor: '#FEFBEC', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div className="bg-white border-b-4 border-[#fbbf24] shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-lg sm:text-xl">🗳️</span>
            </div>
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-gray-800 mb-0.5">
                Alumni Voting
              </h1>
              <p className="text-xs sm:text-sm text-gray-600">
                Cast your vote for alumni leadership positions
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon Content */}
      <div className="container mx-auto px-4 sm:px-6 py-12">
        <div className="max-w-2xl mx-auto">
          <Card className="p-8 sm:p-12 text-center">
            <div className="mb-6">
              <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                <span className="text-5xl">🗳️</span>
              </div>
            </div>
            
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3">
              Voting Coming Soon!
            </h2>
            
            <p className="text-gray-600 mb-6">
              The voting process for alumni leadership positions will begin soon. 
              Please check back later for updates.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-yellow-800">
                <strong>📢 Important Information:</strong><br />
                • Only registered alumni can vote<br />
                • Each alumni can vote once per position<br />
                • Voting will be open for 14 days<br />
                • Results will be announced after voting closes
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/">
                <Button variant="outline">
                  ← Back to Home
                </Button>
              </Link>
              <Link to="/alumni/register">
                <Button variant="outline">
                  Register as Alumnus
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Vote;
